module.exports = __webpack_public_path__ + "static/media/graph-4.2d8ef75b.svg";